module.exports = __webpack_public_path__ + "img/cd.9adef751.jpg";